import { useState, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown, DropdownContent, Button } from 'shared/ui'
import { TYPES_INBOX } from 'entities/Inbox'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationAssignDropdownContent } from 'pages/conversations/ui/ConversationAssignDropdown'
import { useConversationListContext } from 'pages/conversations/ui/ConversationList/context'
import { ButtonMakePriority } from 'pages/conversations/ui/ConversationCard/ui/ConversationDropdown/actions/MakePriority'
import { ButtonManageTags } from 'pages/conversations/ui/ConversationCard/ui/ConversationDropdown/actions/ManageTags'
import { ButtonOptInStatus } from 'pages/conversations/ui/ConversationCard/ui/ConversationDropdown/actions/OptInStatus'
import { ButtonMarkAsPending } from 'pages/conversations/ui/ConversationCard/ui/ConversationDropdown/actions/MarkAsPending'
import { ButtonTransfer } from 'pages/conversations/ui/ConversationCard/ui/ConversationDropdown/actions/Transfer'

type PropsDropDownChildren = {
  callback?: () => void
  onCloseMenu: () => void
  parentDropdownId: string
}

export const DropdownActionsChildren: FC<PropsDropDownChildren> = observer(
  ({ parentDropdownId, onCloseMenu }) => {
    const store = useConversationListContext()
    const { conversationStore, inboxesStore, userPermissionsStore } = useEntitiesContext()
    const { selectedHasUnfavoriteConversation, selectedContactsListIds, selectedListIds } = store
    const { currentItem } = conversationStore
    const { currentInboxType } = inboxesStore

    const [showAssignDropdown, setShowAssignDropdown] = useState(false)
    const onCloseAssignDropdown = () => setShowAssignDropdown(false)

    if (!currentItem) return null

    return (
      <DropdownContent>
        {currentInboxType !== TYPES_INBOX.GROUP && currentInboxType !== TYPES_INBOX.UNIFIED && (
          <Dropdown
            ariaLabel={'DropdownActionsChildren'}
            show={showAssignDropdown}
            onChangeOpen={setShowAssignDropdown}
            parentsDropdownId={[parentDropdownId]}
            width={192}
            margin={-2}
            placement={'right-start'}
            triggerComponent={() => (
              <Button
                fontWeight={400}
                typeBtn='menuItem'
                icon='userLine'
                text='Assign'
                iconRightProps={{
                  icon: 'chevronRight',
                }}
                fullWidth
                onMouseEnter={() => setShowAssignDropdown(true)}
              />
            )}
            customComponent={(onCloseMenuChild) => (
              <ConversationAssignDropdownContent
                store={store.conversationAssignDropdownStore}
                conversationId={currentItem.id}
                isBulk={true}
                show={showAssignDropdown}
                onCloseMenu={() => {
                  onCloseMenuChild()
                  onCloseMenu()
                }}
              />
            )}
          />
        )}
        <ButtonMakePriority
          isFavorite={!selectedHasUnfavoriteConversation}
          clickCallback={onCloseMenu}
          onMouseEnter={onCloseAssignDropdown}
        />
        <ButtonManageTags clickCallback={onCloseMenu} onMouseEnter={onCloseAssignDropdown} />
        <ButtonOptInStatus
          contactsIds={selectedContactsListIds}
          clickCallback={onCloseMenu}
          onMouseEnter={onCloseAssignDropdown}
        />
        <ButtonMarkAsPending clickCallback={onCloseMenu} onMouseEnter={onCloseAssignDropdown} />
        {userPermissionsStore.getItem('can_transfer_conversation') && (
          <ButtonTransfer
            conversationIds={selectedListIds}
            clickCallback={onCloseMenu}
            onMouseEnter={onCloseAssignDropdown}
          />
        )}
      </DropdownContent>
    )
  }
)
